export enum EMessageSendingType {
  SMS = "sms",
  WhatsApp = "whatsapp",
  Email = "email",
}
